export default __webpack_public_path__ + "static/media/mejora.240b8bac.png";